export default {
  title: 'Det ser ud til, at du er offline',
  description: 'Klik på “Genindlæs side” og/eller tjek din internetforbindelse for at sikre, at du er online 😊',
  custom_button: {
    reload: 'Genindlæs side',
  },
};
